import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import isArrayLikeObject from 'lodash/isArrayLikeObject.js';
import isDate from 'lodash/isDate.js';
import isPlainObject from 'lodash/isPlainObject.js';

const isObject = value => Object.prototype.toString.call(value).slice(8, -1) === 'Object';
function pageIsValid(page) {
  return !!(page && page.month && page.year);
}
function pageIsBeforePage(page, comparePage) {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) {
    return false;
  }
  if (page.year === comparePage.year) {
    return page.month < comparePage.month;
  }
  return page.year < comparePage.year;
}
function pageIsAfterPage(page, comparePage) {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) {
    return false;
  }
  if (page.year === comparePage.year) {
    return page.month > comparePage.month;
  }
  return page.year > comparePage.year;
}
function pageIsBetweenPages(page, fromPage, toPage) {
  if (!page) {
    return false;
  }
  return !pageIsBeforePage(page, fromPage) && !pageIsAfterPage(page, toPage);
}
function pageForDate(date) {
  if (!date) {
    return null;
  }
  return {
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
}
function addPages(_ref, count) {
  let {
    month,
    year
  } = _ref;
  const incr = count > 0 ? 1 : -1;
  for (let i = 0; i < Math.abs(count); i++) {
    month += incr;
    if (month > 12) {
      month = 1;
      year++;
    } else if (month < 1) {
      month = 12;
      year--;
    }
  }
  return {
    month,
    year
  };
}
function pageForThisMonth() {
  return pageForDate(new Date());
}
function getMaxPage() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce((prev, curr) => {
    if (!prev) {
      return curr;
    }
    if (!curr) {
      return prev;
    }
    return pageIsAfterPage(curr, prev) ? curr : prev;
  });
}
function datesAreEqual(a, b) {
  const aIsDate = isDate(a);
  const bIsDate = isDate(b);
  if (!aIsDate && !bIsDate) {
    return true;
  }
  if (aIsDate !== bIsDate) {
    return false;
  }
  return a.getTime() === b.getTime();
}
function arrayHasItems(array) {
  return isArrayLikeObject(array) && array.length;
}
function mixinOptionalProps(source, target, props) {
  const assigned = [];
  props.forEach(prop => {
    const name = prop.name || prop.toString();
    const {
      mixin,
      validate
    } = prop;
    if (Object.prototype.hasOwnProperty.call(source, name)) {
      const value = validate ? validate(source[name]) : source[name];
      target[name] = mixin && isPlainObject(value) ? _objectSpread2(_objectSpread2({}, mixin), value) : value;
      assigned.push(name);
    }
  });
  return {
    target,
    assigned: assigned.length ? assigned : null
  };
}

export { addPages, arrayHasItems, datesAreEqual, getMaxPage, isObject, mixinOptionalProps, pageForDate, pageForThisMonth, pageIsAfterPage, pageIsBeforePage, pageIsBetweenPages, pageIsValid };
//# sourceMappingURL=helpers.js.map
